import { render, staticRenderFns } from "./CrudMainScroll.vue?vue&type=template&id=b503e80a&"
import script from "./CrudMainScroll.vue?vue&type=script&lang=js&"
export * from "./CrudMainScroll.vue?vue&type=script&lang=js&"
import style0 from "./CrudMainScroll.vue?vue&type=style&index=0&id=b503e80a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports